/**
 * Project : workspace
 * File    : DateEngine.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package engine.date

import common.util.toLocal
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toInstant
import kotlinx.datetime.toLocalDateTime
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

/**
 * Represents the date engine class.
 */

class DateEngine {
    @OptIn(ExperimentalTime::class)
    fun displayableDate(date: String): String {
        val instantInThePast: Instant = Instant.parse(date)
        var localTime = instantInThePast.toLocalDateTime(TimeZone.UTC)
        localTime = localTime.toInstant(TimeZone.currentSystemDefault()).toLocal()
        val localDate = localTime.date
        return localDate.toString()
    }

    @OptIn(ExperimentalTime::class)
    /**
 * Executes the displayable date time operation.
 *
 * @receiver TODO
 * @param date The date.
 * @return The resulting string.
 */
    fun displayableDateTime(date: String): String {
        if (date.isEmpty()) {
            return ""
        }
        var datetimeInSystemZone: LocalDateTime? = null
        try {
             datetimeInSystemZone = LocalDateTime.parse(date)
        }catch (e:Exception){
            try {
                datetimeInSystemZone = Instant.parse(date).toLocalDateTime(TimeZone.currentSystemDefault())
            }catch (ex:Exception){
                datetimeInSystemZone = LocalDateTime.parse(LocalDateTime.toString())
            }
        }
        var hour = 0
        var amPm = "AM"
        if (datetimeInSystemZone?.hour!! >= 12) {
            amPm = "PM"
        }
        if (datetimeInSystemZone.hour == 24) {
            amPm = "AM"
        }
        if (datetimeInSystemZone.hour > 12) {
            hour = datetimeInSystemZone.hour - 12
        }
        if (datetimeInSystemZone.time.hour == 24) {
            hour = 0
        }
        return "${datetimeInSystemZone.date} at $hour : ${datetimeInSystemZone.time.minute} $amPm"
    }
}